import AuthForm from "./authForm.container";

export default AuthForm;
